<template>
  <div class="choose-screenset">
    <b-tooltip label="Load a saved set of screens.">
      <b-icon
        pack="fas"
        icon="folder-open"
        label="Load Screens"
        v-on:click.native="modalToggle"
      />
    </b-tooltip>
    
    <b-modal

      v-model="modalOpen"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <LoadModal
          v-bind:savedScreens="savedScreens"
          v-bind:parent="this"
        />
    </b-modal>
  </div>
</template>

<script>
import LoadModal from './LoadModal.vue';

export default {
  data() {
    return {
      modalOpen: false,
      savedScreens: {
        a: [],
        loaded: false,
      },
    }
  },
  components: {
    LoadModal,
  },
  methods: {
    modalToggle: function() {
      if (!this.modalOpen) {
        this.loadSavedScreens();
      }
      this.modalOpen = !this.modalOpen;
    },
    loadSavedScreens: function() {
      this.savedScreens.loaded = false;
      fetch('/api/v1/screen_sets/')
        .then((data) => data.json())
        .then((data) => {
          this.savedScreens.a = data.screen_sets;
          this.savedScreens.loaded = true;
          window.history.pushState({}, document.title, window.location.pathname);
        });
    }
  },
}
</script>

<style lang="scss">
.choose-screenset {

  .modal.is-active {

    .modal-card {
      background-color: #fff;
      align-self: center;

      .b-table {
        max-height: 50vh;
        overflow: scroll
      }
    }
  }

}
</style>
